<template>
  <div class="absence-reasons__absence">
    <div>
      <div class="absence-reasons__absence__title"><p><b>{{ reason.title }}</b></p>
        <p>
          <span v-if="isOngoing" class="badge badge--orange badge--small badge--clickable"
                @click="setTheEditAbsenceReason">{{ $t('vue2.subs_ongoing_absence.ongoing_absence') }}</span>
          <span v-if="!isOngoing && getIsAbsenceMultipleDays"
                class="badge badge--small"> {{ $t('vue2.substitution_user.multiple_days') }}</span>
        </p>
      </div>
      <p>
        <template v-if="getSerialListItem">
          {{ getSerialListItem.from_date | date }}
          - {{ getSerialListItem.to_date | date }}, {{ reason.start | showTime }} - {{ reason.end | showTime }}
        </template>
        <template v-else>
          {{ reason.start | showDate }} -
          <span>{{ reason.end | showTime }}</span>
        </template>
      </p>
    </div>
    <div class="absence-reasons__absence__right">
      <div class="absence-reasons__absence__right__edits">
              <span class="icon-bin icon__bg-circle icon__bg-circle--danger deleteAbsence"
                    @click="setReadyToDelete(reason)"
                    :content="$t('vue2.common.delete')"
                    v-tippy="{
                    arrow: true,
                    placement : 'left'
                  }">
      </span>
        <span class="icon-wrench icon__bg-circle"
              v-if="getSerialListItem"
              @click="setTheEditAbsenceReason(reason)"
              :content="$t('vue2.common.edit')"
              v-tippy="{
                    arrow: true,
                    placement : 'left'
                  }">
    </span>
      </div>
      <span class="icon-clock icon__bg-circle"
            @click="showLog(reason)"
            :content="$t('vue2.common.log')"
            v-tippy="{
                    arrow: true,
                    placement : 'left'
                  }">
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    user_calendar_id: {},
    reason: {
      type: Object
    }
  },
  data () {
    return {
      start: this.reason.start,
      end: this.reason.end
    }
  },
  computed: {
    longAbsentList () {
      return this.$store.state.subs.longAbsentList
    },
    longAbsentListInHash () {
      return this.$store.getters.longAbsentListInHash
    },
    getSerialListItem () {
      return this.reason && this.reason.event_serial_id ? this.longAbsentListInHash[this.reason.event_serial_id] : false
    },
    isOngoing () {
      return this.getSerialListItem ? this.getSerialListItem.ongoing : false
    },
    getIsAbsenceMultipleDays () {
      let serialItem = this.getSerialListItem
      return serialItem && moment(serialItem.from_date).format('YYYY-MM-DD') !== moment(serialItem.to_date).format('YYYY-MM-DD')
    }
  },
  filters: {
    showDate (date) {
      return moment(date).format('DD. MMM, LT')
    },
    showTime (date) {
      return moment(date).format('LT')
    },
    date (date) {
      return moment(date).format('ll')
    }
  },
  methods: {
    showLog (event) {
      this.$emit('showLog', event)
    },
    setReadyToDelete () {
      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true)
      this.$store.commit('setActiveAbsenceReason', this.reason)
    },
    isEndDateSameDayAsStart (startDate, endDate) {
      const start = moment(startDate).format('YYYY-MM-DD')
      const end = moment(endDate).format('YYYY-MM-DD')
      return moment(start).isSame(end)
    },
    setTheEditAbsenceReason () {
      let absence = this.getSerialListItem ? this.getSerialListItem : this.reason
      this.$store.commit('setActiveAbsenceReason', absence)
    },
    getIsAbsenceOngoing (reason) {
      return this.getSerialListItem && this.getSerialListItem.ongoing
    }
  },
  mounted () {
    this.$emit('start', this.start)
    this.$emit('end', this.end)
    this.$store.dispatch('subsGetLongAbsenceList')
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.absence-reasons__absence {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 2px 6px;
  margin-bottom: 5px;
}

.absence-reasons__absence > div:first-child {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.deleteAbsence > span {
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  color: #8e8e93;
  font-size: 14px;
  padding: 5px;
}

.deleteAbsence > span:hover {
  transition: all 0.25s;
  background-color: var(--danger);
  color: white;
}

h4.go_to_calendar {
  text-align: left;
}

.absence-reasons__absence__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

.absence-reasons__absence__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.absence-reasons__absence__right__edits {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// SubsUserAbsenceReason.vue?82ea43a6